import algoliasearch from 'algoliasearch/lite';

const searchClient = () => {
  return algoliasearch(process.env.REACT_APP_ALGOLIA_APP_ID, process.env.REACT_APP_ALGOLIA_API_KEY);
};

const initIndex = (indexName) => {
  return searchClient().initIndex(indexName);
};


export {searchClient, initIndex};
